import React from 'react';
import { Navigate } from 'react-router-dom';
import RequireAuth from '../components/auth/RequireAuth';
import LaunchPage from '../components/LaunchPage/LaunchPage';
import RefinedLandingPage from '../components/RefinedLandingPage/RefinedLandingPage';
import { useAuth } from '../context/AuthContext';
import { isLaunchMode } from './launchMode';

/** Home: gated to auth only while launch mode is on; public landing otherwise (pre-launch behavior). */
export function LaunchAwareHome() {
  if (isLaunchMode()) {
    return (
      <RequireAuth>
        <RefinedLandingPage />
      </RequireAuth>
    );
  }
  return <RefinedLandingPage />;
}

/** `/launch` exists only in launch mode; authenticated users belong on home (`/`). */
export function LaunchAwareLaunchPage() {
  const { user, loading } = useAuth();

  if (!isLaunchMode()) {
    return <Navigate to="/" replace />;
  }
  if (!loading && user) {
    return <Navigate to="/" replace />;
  }
  return <LaunchPage />;
}
